// Copyright (c) 2017 Deere & Company

import PIpHistoryReport from '../../../reports/pip-history/state-connector';

export default {
    component: PIpHistoryReport,
    name: 'PIP_HISTORY',
    path: 'pip-history'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/reports/pip-history.js